import { useEffect, useMemo, useState } from 'react';
import { isMobile, isTablet } from '../../utils/responsividade/is-mobile';
import { ResponsividadeHook } from './responsividade.types';

export const useResponsividade: ResponsividadeHook = () => {
  const [mobile, setMobile] = useState(isMobile());
  const [tablet, setTablet] = useState(isTablet());

  useEffect(() => {
    function handleResize() {
      setMobile(isMobile());
      setTablet(isTablet());
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [setMobile, setTablet]);

  const result = useMemo(
    () => ({
      mobile,
      desktop: !mobile,
      tablet,
    }),
    [mobile, tablet],
  );

  return result;
};
